import { render } from "./NotificationPage.vue?vue&type=template&id=21e0d6a5&scoped=true&ts=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"

import "./NotificationPage.vue?vue&type=style&index=0&id=21e0d6a5&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QuanLy_Spa/QuanLy_Spa_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e0d6a5"]])

export default __exports__